import React from 'react';
import PropTypes from 'prop-types';

import ButtonMenuList from '../Button/ButtonMenuList';

function LowerMenu({ me, availableModule }) {
  return (
    <div className="min-h-screen bg-white">
      <div className="h-96"></div>
      <div className="container mr-auto ml-auto">
        <ButtonMenuList me={me} availableModule={availableModule} />
      </div>
    </div>
  );
}

export default LowerMenu;

LowerMenu.propTypes = {
  me: PropTypes.object,
  availableModule: PropTypes.arrayOf(PropTypes.object),
  information: PropTypes.object,
};
